import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MarketingAnalyticsService {
  constructor(private api: ApiService) {}

  getOverview(data: {
    client_id: string | number;
    from: string;
    to: string;
    limit?: number;
  }): Observable<any> {
    return this.api.post(environment.getMarketingAnalytics, data);
  }
}
